import { render, staticRenderFns } from "./Bottomnavbar.vue?vue&type=template&id=7bf0a8b6&scoped=true&"
import script from "./Bottomnavbar.vue?vue&type=script&lang=js&"
export * from "./Bottomnavbar.vue?vue&type=script&lang=js&"
import style0 from "./Bottomnavbar.vue?vue&type=style&index=0&id=7bf0a8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0a8b6",
  null
  
)

export default component.exports